<template>
    <modal
        title="Fotos & Dateien"
        ref="modal"
        :showDismissMessage="showDismissMessage"
    >
        <form @submit.prevent="submitForm">
            <files-upload
                class="ion-margin-bottom"
                v-model="files"
                :existingFiles="existingFiles"
                :multiple="isMultiple"
                :maxFiles="maxFiles"
                @delete-existing-file="deleteExistingFile"
                id="file"
                disabled
            ></files-upload>
            <base-input
                class="ion-margin-bottom"
                type="text"
                v-model="formData.name"
                label="Titel"
                id="name"
                disabled
            ></base-input>
            <base-datetime
                class="ion-margin-bottom"
                label="Datum"
                v-model="formData.date"
                id="date"
                disabled
            ></base-datetime>
            <base-select
                class="ion-margin-bottom"
                id="categoryId"
                v-model="formData.categoryId"
                label="Ordner"
                disabled
            >
                <ion-select-option
                    v-for="(category, index) in $store.state.dokbox.details
                        .categories"
                    :key="index"
                    :value="category.id"
                    >{{ category.name }}</ion-select-option
                >
            </base-select>
            <base-textarea
                class="ion-margin-bottom"
                id="desc"
                :value="immowertDescription || formData.desc"
                @input="$set(formData, 'desc', $event)"
                label="Beschreibung"
                disabled
            ></base-textarea>
            <!-- <ion-item lines="none">
        <base-checkbox
          id="ispublic"
          v-model="formData.ispublic"
        ></base-checkbox>
        <ion-label text-wrap>Öffentlich freigeben</ion-label>
      </ion-item> -->
            <!-- <ion-item lines="none">
                <base-checkbox
                    id="beraterinfo"
                    v-model="formData.beraterinfo"
                ></base-checkbox>
                <ion-label text-wrap
                    >Fotos & Dateien an Berater senden</ion-label
                >
            </ion-item>
            <base-textarea
                v-if="formData.beraterinfo"
                id="beratertext"
                v-model="formData.beratertext"
                label="Deine Nachricht an deinen Berater"
            ></base-textarea> -->
        </form>
        <template v-slot:footer>
            <ion-button
                fill="outline"
                expand="block"
                class="ion-margin-top"
                @click="$ionic.modalController.dismiss()"
                >Schließen</ion-button
            >
            <!-- <ion-button
                expand="block"
                class="ion-margin-top"
                @click="submitForm()"
                v-if="
                    files.length === 0 &&
                    existingFiles.length === 0 &&
                    existingFilesToDelete.length !== 0
                "
                >Löschen</ion-button
            >
            <ion-button
                expand="block"
                class="ion-margin-top"
                @click="submitForm()"
                v-else-if="
                    existingFiles.length !== 0 ||
                    existingFilesToDelete.length !== 0
                "
                >Speichern</ion-button
            >
            <ion-button
                expand="block"
                class="ion-margin-top"
                @click="submitForm()"
                :disabled="files.length === 0"
                v-else
                >Hochladen</ion-button
            > -->
        </template>
    </modal>
</template>

<script>
import Modal from "./Modal";
import BaseDatetime from "./BaseDatetime";
import BaseInput from "./BaseInput";
import BaseSelect from "./BaseSelect";
import BaseTextarea from "./BaseTextarea";
// import BaseCheckbox from "./BaseCheckbox";
import FilesUpload from "@/components/FilesUpload";
import { dokbox } from "@/mixins/dokbox";

export default {
    mixins: [dokbox],
    props: {
        fileGroupIndex: {
            type: Number,
            required: false,
        },
    },
    components: {
        Modal,
        BaseDatetime,
        BaseInput,
        BaseSelect,
        BaseTextarea,
        // BaseCheckbox,
        FilesUpload,
    },
    data() {
        return {
            isTitleDisabled: false,
            isFolderDisabled: false,
            isDescriptionDisabled: false,
            immowertDescription: "",
            isMultiple: true,
            maxFiles: 10,
        };
    },
    mounted() {
        this.$store.dispatch("dokbox/getDokbox");
        if (this.fileGroupIndex !== undefined) {
            const fileGroup = this.$store.getters["dokbox/fileGroups"][
                this.fileGroupIndex
            ];
            this.formData.name = fileGroup.name;
            this.formData.categoryId = String(fileGroup.categoryId);
            this.formData.desc = fileGroup.description;
            this.formData.date = fileGroup.date;
            this.formData.ispublic = fileGroup.ispublic;
            this.existingFormData = Object.assign({}, this.formData);
            for (let file of fileGroup.files) {
                let existingFile = {
                    id: file.fileId,
                    url: file.fileThumbnailUrl,
                    fileType: file.fileType,
                    fileHash: file.fileHash,
                    downloadUrl: file.fileDownloadUrl,
                };
                this.existingFiles.push(existingFile);
            }
            if (fileGroup.name.startsWith("ImmoWert - ")) {
                this.isTitleDisabled = true;
                this.isFolderDisabled = true;
                this.isDescriptionDisabled = true;
                this.isMultiple = false;
                this.maxFiles = 1;
                const immowertValues = this.formData.desc.split("###");
                this.immowertDescription =
                    "Baujahr: " +
                    (immowertValues[3] === "0"
                        ? "lagemäßig"
                        : immowertValues[3]) +
                    "\n" +
                    "Fläche: " +
                    (immowertValues[4] === "0"
                        ? "lagemäßig"
                        : immowertValues[4] + " m²");
            } else if (fileGroup.name.startsWith("Gemeinsam gesund - ")) {
                this.isTitleDisabled = true;
                this.isFolderDisabled = true;
            }
        } else {
            this.changeformDataCount++;
        }
    },
};
</script>

<style></style>
